import { z } from 'zod';

import { type ChatSession } from '../assistant/index.js';
import { FeedbackType } from '../feedback.js';

export enum FlowBuilderAssistantChatResponseMessageStatus {
  Streaming = 'Streaming',
  Finished = 'Finished',
}

export const flowBuilderAssistantChatResponseSchema = z.object({
  answer: z.string(),
  chatMessageId: z.uuid().optional(),
  intent: z.string().nullable(),
  entities: z.record(z.string(), z.unknown()),
  messageStatus: z.nativeEnum(FlowBuilderAssistantChatResponseMessageStatus),
});

export type FlowBuilderAssistantChatResponse = z.infer<
  typeof flowBuilderAssistantChatResponseSchema
>;

export const flowBuilderAssistantSubmitMessageFeedbackRequestSchema = z.object({
  messageId: z.uuid(),
  feedback: z.nativeEnum(FeedbackType),
  comment: z.string().optional(),
});

export type FlowBuilderAssistantSubmitMessageFeedbackRequest = z.infer<
  typeof flowBuilderAssistantSubmitMessageFeedbackRequestSchema
>;

export interface FlowBuilderAssistantFindSessionsResponse {
  chatSessions: ChatSession[];
}
